export default "__VITE_ASSET__2a6703b5__"